import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(1.5 1.5)">
    <rect width="16" height="16" rx="4" fill={fill} />
    <path
      d="M4.24902 7.5C4.93938 7.5 5.49902 6.94036 5.49902 6.25C5.49902 5.55964 4.93938 5 4.24902 5C3.55867 5 2.99902 5.55964 2.99902 6.25C2.99902 6.94036 3.55867 7.5 4.24902 7.5Z"
      fill="white"
    />
    <path d="M6.5 11L5 9L2 13H14L9.5 7L6.5 11Z" fill="white" />
  </g>
);

export default Icon;
